import script from "./TTextareaElement.vue?vue&type=script&lang=js"
export * from "./TTextareaElement.vue?vue&type=script&lang=js"

import "./TTextareaElement.vue?vue&type=style&index=0&id=6260418d&lang=scss"

const __exports__ = script;

export default __exports__